import React, { Component } from "react";
import PropTypes from "prop-types";
import { View,TouchableHighlight, StyleSheet } from "react-native";
import Text from "./TextFont";
import { translate } from "../locales/translate";
import ArTheme from "../argon-ui/Theme";
import { SimpleIcon } from "./Buttons";
import { faBatteryEmpty, faBatterySlash } from "../../assets/consts/faCharCodes";

/**@augments{Component<Props,state>} */
class LowBatteryMessage extends Component {
  static propTypes = {
    count: PropTypes.number.isRequired,
    onButtonPress: PropTypes.func,
    style: PropTypes.oneOfType([PropTypes.shape(), PropTypes.array]),
  };

  handleOnButtonPress = () => {
    typeof this.props.onButtonPress === "function" &&
      this.props.onButtonPress();
  };

  render() {
    var _count = this.props.count || 0;
    var _style = this.props.style || {};
    if (_count > 0)
      return (
        <View style={[styles.container, _style]}>
          <View style={{flexDirection :"row", alignItems:"center"}}>
          <SimpleIcon icon={faBatterySlash} color={ArTheme.COLORS.ERROR} size={13} />
          <Text style={styles.message}>
            {translate("device.devicesWithLowBattery", { count: _count })}
          </Text>
          </View>
          <TouchableHighlight
            style={styles.btnView}
            underlayColor="#FFF"
            onPress={this.handleOnButtonPress}
          >
            <Text style={{ color: "#FFF",fontSize:12 }}>
              {translate("device.viewDevicesWithLowBattery")}
            </Text>
          </TouchableHighlight>
        </View>
      );
    else return null;
  }
}

const styles = StyleSheet.create({
  container: {
    padding: 6,
    borderRadius: 5,
    backgroundColor: "#ffe8ef",
    // borderColor:"#ff80a8",
    // borderWidth: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  message: {
    color: ArTheme.COLORS.ERROR,
    marginEnd: 5,
    fontSize:12
  },
  btnView: {
    backgroundColor: ArTheme.COLORS.ERROR,
    borderRadius: 5,
    paddingVertical: 3,
    paddingHorizontal: 8,
  },
});

export default LowBatteryMessage;
